import { Vue } from "vue-property-decorator";
import moment from 'moment-timezone';
import Event from '../models/Event';
import CartManager from '../services/CartManager';
import Occurrence from '../models/Occurrence';
import DataProviderService from "../services/DataProviderService";

export default class TicketWidgetComponent extends Vue {

    dmnResources: any = (<any>Vue).dmnResources;
    $appSize: any = (<any>Vue).$appSize;

    /**
     * @desc prepares the API request for sending to checkout
     */
    get cartManager() : CartManager {
        return this.$root.$data.cartManager;
    }

    /**
     * @desc prepares the API request for sending to checkout
     */
    get checkoutMode() : string {
        return this.$root.$data.dmnOptions.checkoutMode;
    }

    /**
    * @return {Object}
    */
    get currentStage() {
        return this.$root.$data.config.currentStage;
    }

    /**
    * @return {DataProviderService}
    */
    get dataProviderService(): DataProviderService {
        return this.$root.$data.dataProviderService;
    }

    /**
    * @return {TagOptions}
    */
    get dmnOptions() {
        return this.$root.$data.dmnOptions;
    }

    /**
    * @return {Array<Event>}
    */
    get events() : Event[] {
        return this.$root.$data.events;
    }

    /**
     * @return {boolean}
     */
    get hideTicketDesc() : boolean {
        return this.$root.$data.dmnOptions.hideTicketDesc;
    }

    /**
     * @return {Event}
     */
    get selectedEvent() : Event {
        return this.$root.$data.selectedEvent;
    }

    /**
    * @param {Event}
    */
    set selectedEvent(event: Event) {
        this.$root.$data.selectedEvent = event;
    }

    /**
     * @return {Occurrence}
     */
    get selectedOccurrence() {
        let availableToSell = this.$root.$data.selectedOccurrence.ticket_types;
        for (let key in availableToSell) {
            if (availableToSell[key]['status'] == 'private'){
                delete availableToSell[key];
            }
        }
        this.$root.$data.selectedOccurrence.ticket_types = availableToSell;
        return this.$root.$data.selectedOccurrence;
    }

    /**
    * @param {Occurrence}
    */
    set selectedOccurrence(occurrence: any) {
        this.$root.$data.selectedOccurrence = occurrence;
    }

    /**
    * @return {moment.Moment}
    */
    get serverTime() : moment.Moment {
        return this.$root.$data.serverTime;
    }

    /**
    * @return {moment.Moment}
    */
    set serverTime(serverTime: moment.Moment) {
        this.$root.$data.serverTime = serverTime;
    }

    /**
     * @returns {boolean}
     */
    get showCheckoutError() {
        return this.$root.$data.showCheckoutError || false;
    }

    /**
    * @param {boolean}
    */
    set showCheckoutError(showError: boolean) {
        this.$root.$data.showCheckoutError = showError;
    }

    /**
     * @returns {string|undefined}
     */
    get checkoutErrorMessage() {
        return this.$root.$data.checkoutErrorMessage || undefined;
    }

    /**
     * @param {string}
     */
    set checkoutErrorMessage(message: string) {
        this.$root.$data.checkoutErrorMessage = message;
    }
}
